var render, staticRenderFns
import script from "./TabsContentContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsContentContainer.vue?vue&type=style&index=0&id=0a23f79f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a23f79f",
  null
  
)

export default component.exports